import React from "react";
import { Col, Container, Image, Row } from "react-bootstrap";
import boston_logo from "../../images/institutions/logo/boston_logo.png";
import berkley_logo from "../../images/institutions/logo/berkley_logo.png";
import harward_logo from "../../images/institutions/logo/harward_logo.png";
import IBMLogo from "../../images/institutions/logo/IBMLogo.webp";
import aws from "../../images/institutions/logo/aws.webp";
import oxford_logo_ from "../../images/institutions/logo/oxford_logo_.webp";
import "./Logo.css";

export default function Logo() {
  return (
    <Container className="logo-padding">
      <div className="logo-structure">
        <h3>Learn skills taught by the world's leading experts</h3>
        <p>Choose from over 3000 courses across in-demand subject areas</p>
      </div>
      <Row>
        <Col lg={4} md={4} sm={6}>
          <Image src={boston_logo} fluid />
        </Col>
        <Col lg={4} md={4} sm={6}>
          <Image src={berkley_logo} fluid />
        </Col>
        <Col lg={4} md={4} sm={6}>
          <Image src={harward_logo} fluid />
        </Col>
        <Col lg={4} md={4} sm={6}>
          <Image src={aws} fluid />
        </Col>
        <Col lg={4} md={4} sm={6}>
          <Image src={IBMLogo} fluid />
        </Col>
        <Col lg={4} md={4} sm={6}>
          <Image src={oxford_logo_} fluid />
        </Col>
      </Row>
    </Container>
  );
}
